import React from 'react'
import Image from 'next/image'
import { AssetContentType, RichTextAssetType } from './types'
import styles from './renderAssets.module.css'
import { RenderOptions } from './renderOptions'
import classNames from 'classnames'
const isImage = (contentType: AssetContentType) => {
  if (contentType === 'image/jpeg' || contentType === 'image/png') {
    return true
  }
}

const isVideo = (contentType: AssetContentType) => {
  if (contentType === 'video/mp4' || contentType === 'video/webm') {
    return true
  }
}

const isAudio = (contentType: AssetContentType) => {
  if (
    contentType === 'audio/mp3' ||
    contentType === 'audio/ogg' ||
    contentType === 'audio/wav' ||
    contentType === 'audio/x-wav'
  ) {
    return true
  }
}

export const renderEmbeddedAssets = (asset: RichTextAssetType, options: RenderOptions) => {
  const { contentType } = asset

  // Video handling
  if (isVideo(contentType)) {
    return (
      <video width="100%" controls>
        <source src={asset.url} type={contentType} />
      </video>
    )
  }

  // Audio handling
  if (isAudio(contentType)) {
    return <audio src={asset.url} controls />
  }

  // Image handling
  if (isImage(contentType)) {
    return (
      <div className={classNames(styles.imageContainer, { [styles.decorateImages]: options.decorateImages })}>
        <Image
          src={asset.url + '?w=1300&'}
          alt={asset.description || ''}
          width={asset.width}
          height={asset.height}
          sizes="100vw"
          placeholder="blur"
          blurDataURL={asset.url + '?w=300&q=10'}
          style={{
            width: '100%',
            height: 'auto',
          }}
        />
      </div>
    )
  }

  // Should we default handle embedded assets?
  // Maybe just return a link to the asset?
  return <span className={styles.unsupportedMedia}>Unsupported media type ({contentType})</span>
}
